import { createSlice } from '@reduxjs/toolkit';
import {
  fetchEleQcParams,
  fetchEles3params,
  fetchRmpuChecksheetParams,
  fetchFrameType,
  storeRoofPrecellingData,
  fetchRoofPrecellingList,
  updateRoofPrecellingFlowStatus,
  fetchRoofPrecellingHistory,
  fetchRoofPrecellingViewData,
  fetchCoachNo,
  fetchFqaList,
  getElectricalInspectionData,
  fetchFireSafetyParams,
  fetchAirDeliveryDataParams,
  getElectricalFireSafetyList,
  fetchRMPUChecksheetData,
  saveRMPUChecksheetData,
  rmpuInspectionAction,
  deleteRMPUChecksheet,
  fetchRMPUChecksheetStageById,
  fetchRMPUChecksheetViewData,
  fetchRMPUFlowHistory,
  fetchElectricalDashboard,
  fetchCoachNoByFrameType,
  addQFRPreCeilingData,
  addTractionMotorVB,
  fetchListTractionMotorVB,
  fetchTractionMotorVBById,
  tractionMotorInspectionActionVB,
  fetchTractionMotorVBFlowHistory,
  deleteTractionMotorVB,
  checkRecordExist,
  createAirDelivery,
  fetchAirDeliveryList,
  updateAirDeliveryFlowStatus,
  deleteAirDelivery, 
} from './electricalThunk';

const initialState = {
  eles3Params: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  filters: {
    date_from: '',
    date_to: '',
    shift: '',
    shellType: '',
    module: '',
  },
  shifts: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  shellTypes: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  eleqcParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  rmpuChecksheetParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  frameTypes: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  roofPrecelling: {
    loading: false,
    success: false,
    error: null,
    data: [],
    total: 0,
  },
  storeRoofPrecelling: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  updateFlowStatus: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  roofPrecellingHistory: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  roofPrecellingViewData: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  getCoachNo: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  fetchFqaList: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  getElectricalInspectionData: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  getEleFinalQualityInspectionList: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  fireSafetyParams: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  airDeliveryDataParams: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  ElectricalFireSafetyParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  storedRMPUData: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  rmpuList: {
    loading: false,
    success: false,
    error: null,
    data: [],
    total: 0,
  },
  rmpuStageById: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  deleteRMPU: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  rmpuAction: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  rmpuViewData: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  rmpuFlowHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  dashboardData: {
    loading: false,
    success: false,
    error: null,
    data: null,
    isFiltered: false,
  },
  coachNoData: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  storeQrfPreceilingData: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  TractionMotorVBStoreData: {
    loading: false,
    data: null,
    error: null,
  },
  TractionMotorVBListData: {
    loading: false,
    success: false,
    data: [],
    pagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
      total_pages: 0,
    },
    error: null,
  },
  tractionMotorVBDetail: {
    loading: false,
    data: null,
    error: null,
  },
  tractionMotorVBFlowHistory: {
    loading: false,
    data: null,
    error: null,
  },
  deleteTractionData: {
    loading: false,
    data: null,
    error: null,
  },
  checkRecord: {
    loading: false,
    data: null,
    error: null,
    exists: false
  },
  createAirDelivery: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  airDeliveryList: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
      total_pages: 0,
    },
  },
  updateAirDeliveryFlowStatus: {
  loading: false,
  success: false,
  error: null,
  data: null,
},
deleteAirDelivery: {
  loading: false,
  success: false,
  error: null,
  data: null,
},
};

const electricalSlice = createSlice({
  name: 'electrical',
  initialState,
  reducers: {
    resetStoreRoofPrecelling: (state) => {
      state.storeRoofPrecelling = {
        loading: false,
        success: false,
        error: null,
        data: null,
      };
    },
    resetUpdateFlowStatus: (state) => {
      state.updateFlowStatus = {
        loading: false,
        success: false,
        error: null,
        data: null,
      };
    },

    clearRoofPrecellingHistory: (state) => {
      state.roofPrecellingHistory = {
        loading: false,
        success: false,
        error: null,
        data: null,
      };
    },

    resetRoofPrecellingView: (state) => {
      state.roofPrecellingViewData = {
        loading: false,
        success: false,
        error: null,
        data: null,
      };
    },

    getEleFinalQualityInspectionList: (state) => {
      state.getEleFinalQualityInspectionList = {
        loading: false,
        success: false,
        error: null,
        data: [],
      };
    },
    clearFinalQualityParams: (state) => {
      state.eleqcParams = {
        loading: false,
        success: false,
        error: null,
        data: null,
      };
    },
    resetDashboard: (state) => {
      state.dashboardData = {
        loading: false,
        success: false,
        error: null,
        data: null,
      };
    },
    // Filter reducers - Updated with date_from and date_to
    setDateFromFilter: (state, action) => {
      state.filters.date_from = action.payload;
    },
    setDateToFilter: (state, action) => {
      state.filters.date_to = action.payload;
    },
    setShiftFilter: (state, action) => {
      state.filters.shift = action.payload;
    },
    setShellTypeFilter: (state, action) => {
      state.filters.shellType = action.payload;
    },
    resetFilters: (state) => {
      state.filters = {
        date_from: '',
        date_to: '',
        shift: '',
        shellType: '',
        module: '',
      };
    },
    // Air Delivery Reducer
    resetCreateAirDeliveryState: (state) => {
      state.createAirDelivery.loading = false;
      state.createAirDelivery.success = false;
      state.createAirDelivery.error = null;
      state.createAirDelivery.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchEles3params
      .addCase(fetchEles3params.pending, (state) => {
        state.eles3Params.loading = true;
        state.eles3Params.error = null;
      })
      .addCase(fetchEles3params.fulfilled, (state, action) => {
        state.eles3Params.loading = false;
        state.eles3Params.data = action.payload;
        state.eles3Params.success = true;
      })
      .addCase(fetchEles3params.rejected, (state, action) => {
        state.eles3Params.loading = false;
        state.eles3Params.error = action.payload || 'Something went wrong';
        state.eles3Params.success = false;
      })

      // fetchEleQcParams
      .addCase(fetchEleQcParams.pending, (state) => {
        state.eleqcParams.loading = true;
        state.eleqcParams.error = null;
      })
      .addCase(fetchEleQcParams.fulfilled, (state, action) => {
        state.eleqcParams.loading = false;
        state.eleqcParams.data = action.payload;
        state.eleqcParams.success = true;
      })
      .addCase(fetchEleQcParams.rejected, (state, action) => {
        state.eleqcParams.loading = false;
        state.eleqcParams.error = action.payload || 'Something went wrong';
        state.eleqcParams.success = false;
      })

      // fetchRmpuChecksheetParams
      .addCase(fetchRmpuChecksheetParams.pending, (state) => {
        state.rmpuChecksheetParams.loading = true;
        state.rmpuChecksheetParams.error = null;
      })
      .addCase(fetchRmpuChecksheetParams.fulfilled, (state, action) => {
        state.rmpuChecksheetParams.loading = false;
        state.rmpuChecksheetParams.data = action.payload;
        state.rmpuChecksheetParams.success = true;
      })
      .addCase(fetchRmpuChecksheetParams.rejected, (state, action) => {
        state.rmpuChecksheetParams.loading = false;
        state.rmpuChecksheetParams.error = action.payload || 'Something went wrong';
        state.rmpuChecksheetParams.success = false;
      })

      // fetchFrameType
      .addCase(fetchFrameType.pending, (state) => {
        state.frameTypes.loading = true;
        state.frameTypes.error = null;
      })
      .addCase(fetchFrameType.fulfilled, (state, action) => {
        state.frameTypes.loading = false;
        state.frameTypes.data = action.payload;
        state.frameTypes.success = true;
      })
      .addCase(fetchFrameType.rejected, (state, action) => {
        state.frameTypes.loading = false;
        state.frameTypes.error = action.payload || 'Something went wrong';
        state.frameTypes.success = false;
      })

      // storeRoofPrecellingData
      .addCase(storeRoofPrecellingData.pending, (state) => {
        state.storeRoofPrecelling.loading = true;
        state.storeRoofPrecelling.error = null;
        state.storeRoofPrecelling.success = false;
      })
      .addCase(storeRoofPrecellingData.fulfilled, (state, action) => {
        state.storeRoofPrecelling.loading = false;
        state.storeRoofPrecelling.success = true;
        state.storeRoofPrecelling.data = action.payload;
      })
      .addCase(storeRoofPrecellingData.rejected, (state, action) => {
        state.storeRoofPrecelling.loading = false;
        state.storeRoofPrecelling.success = false;
        state.storeRoofPrecelling.error = action.payload || 'Something went wrong';
      })

      // fetchRoofPrecellingList
      .addCase(fetchRoofPrecellingList.pending, (state) => {
        state.roofPrecelling.loading = true;
        state.roofPrecelling.error = null;
      })
      .addCase(fetchRoofPrecellingList.fulfilled, (state, action) => {
        state.roofPrecelling.loading = false;
        state.roofPrecelling.success = true;
        state.roofPrecelling.data = action.payload?.data || [];
        state.roofPrecelling.total = action.payload?.total || 0;
      })
      .addCase(fetchRoofPrecellingList.rejected, (state, action) => {
        state.roofPrecelling.loading = false;
        state.roofPrecelling.success = false;
        state.roofPrecelling.error = action.payload || 'Something went wrong';
      })

      // updateRoofPrecellingFlowStatus
      .addCase(updateRoofPrecellingFlowStatus.pending, (state) => {
        state.updateFlowStatus.loading = true;
        state.updateFlowStatus.error = null;
        state.updateFlowStatus.success = false;
      })
      .addCase(updateRoofPrecellingFlowStatus.fulfilled, (state, action) => {
        state.updateFlowStatus.loading = false;
        state.updateFlowStatus.success = true;
        state.updateFlowStatus.data = action.payload;
      })
      .addCase(updateRoofPrecellingFlowStatus.rejected, (state, action) => {
        state.updateFlowStatus.loading = false;
        state.updateFlowStatus.success = false;
        state.updateFlowStatus.error = action.payload || 'Something went wrong';
      })

      // fetchRoofPrecellingHistory
      .addCase(fetchRoofPrecellingHistory.pending, (state) => {
        state.roofPrecellingHistory.loading = true;
        state.roofPrecellingHistory.error = null;
        state.roofPrecellingHistory.success = false;
      })
      .addCase(fetchRoofPrecellingHistory.fulfilled, (state, action) => {
        state.roofPrecellingHistory.loading = false;
        state.roofPrecellingHistory.success = true;
        state.roofPrecellingHistory.data = action.payload;
      })
      .addCase(fetchRoofPrecellingHistory.rejected, (state, action) => {
        state.roofPrecellingHistory.loading = false;
        state.roofPrecellingHistory.success = false;
        state.roofPrecellingHistory.error = action.payload || 'Something went wrong';
      })

      .addCase(fetchRoofPrecellingViewData.pending, (state) => {
        state.roofPrecellingViewData.loading = true;
        state.roofPrecellingViewData.error = null;
      })
      .addCase(fetchRoofPrecellingViewData.fulfilled, (state, action) => {
        state.roofPrecellingViewData.loading = false;
        state.roofPrecellingViewData.success = true;
        state.roofPrecellingViewData.data = action.payload;
      })
      .addCase(fetchRoofPrecellingViewData.rejected, (state, action) => {
        state.roofPrecellingViewData.loading = false;
        state.roofPrecellingViewData.success = false;
        state.roofPrecellingViewData.error = action.payload || 'Something went wrong';
      })
      .addCase(fetchCoachNo.pending, (state) => {
        state.getCoachNo.loading = true;
        state.getCoachNo.error = null;
      })
      .addCase(fetchCoachNo.fulfilled, (state, action) => {
        state.getCoachNo.loading = false;
        state.getCoachNo.data = action.payload.data;
      })
      .addCase(fetchCoachNo.rejected, (state, action) => {
        state.getCoachNo.loading = false;
        state.getCoachNo.error = action.payload || 'Somthing wents wrong.';
      })
      .addCase(fetchFqaList.pending, (state) => {
        state.getEleFinalQualityInspectionList.loading = true;
        state.getEleFinalQualityInspectionList.error = null;
      })
      .addCase(fetchFqaList.fulfilled, (state, action) => {
        state.getEleFinalQualityInspectionList.loading = false;
        state.getEleFinalQualityInspectionList.data = action.payload.data;
      })
      .addCase(fetchFqaList.rejected, (state, action) => {
        state.getEleFinalQualityInspectionList.loading = false;
        state.getEleFinalQualityInspectionList.error = action.payload || 'Somthing wents wrong.';
      })
      .addCase(getElectricalInspectionData.pending, (state) => {
        state.getElectricalInspectionData.loading = true;
        state.getElectricalInspectionData.error = null;
      })
      .addCase(getElectricalInspectionData.fulfilled, (state, action) => {
        state.getElectricalInspectionData.loading = false;
        state.getElectricalInspectionData.data = action.payload.data;
      })
      .addCase(getElectricalInspectionData.rejected, (state, action) => {
        state.getElectricalInspectionData.loading = false;
        state.getElectricalInspectionData.error = action.payload || 'Somthing wents wrong.';
      })

      .addCase(fetchFireSafetyParams.pending, (state) => {
        state.fireSafetyParams.loading = true;
        state.fireSafetyParams.error = null;
        state.fireSafetyParams.success = false;
      })
      .addCase(fetchFireSafetyParams.fulfilled, (state, action) => {
        state.fireSafetyParams.loading = false;
        state.fireSafetyParams.success = true;
        state.fireSafetyParams.data = action.payload;
      })
      .addCase(fetchFireSafetyParams.rejected, (state, action) => {
        state.fireSafetyParams.loading = false;
        state.fireSafetyParams.success = false;
        state.fireSafetyParams.error = action.payload || 'Something went wrong';
      })
      .addCase(fetchAirDeliveryDataParams.pending, (state) => {
        state.airDeliveryDataParams.loading = true;
        state.airDeliveryDataParams.error = null;
        state.airDeliveryDataParams.success = false;
      })
      .addCase(fetchAirDeliveryDataParams.fulfilled, (state, action) => {
        state.airDeliveryDataParams.loading = false;
        state.airDeliveryDataParams.success = true;
        state.airDeliveryDataParams.data = action.payload;
      })
      .addCase(fetchAirDeliveryDataParams.rejected, (state, action) => {
        state.airDeliveryDataParams.loading = false;
        state.airDeliveryDataParams.success = false;
        state.airDeliveryDataParams.error = action.payload || 'Something went wrong';
      })
      .addCase(getElectricalFireSafetyList.pending, (state) => {
        state.ElectricalFireSafetyParams.loading = true;
        state.ElectricalFireSafetyParams.error = null;
      })
      .addCase(getElectricalFireSafetyList.fulfilled, (state, action) => {
        state.ElectricalFireSafetyParams.loading = false;
        state.ElectricalFireSafetyParams.data = action.payload.data;
      })
      .addCase(getElectricalFireSafetyList.rejected, (state, action) => {
        state.ElectricalFireSafetyParams.loading = false;
        state.ElectricalFireSafetyParams.error = action.payload || 'Somthing wents wrong.';
      })
      .addCase(saveRMPUChecksheetData.pending, (state) => {
        state.storedRMPUData.loading = true;
        state.storedRMPUData.error = null;
        state.storedRMPUData.success = false;
      })
      .addCase(saveRMPUChecksheetData.fulfilled, (state, action) => {
        state.storedRMPUData.loading = false;
        state.storedRMPUData.success = true;
        state.storedRMPUData.data = action.payload;
      })
      .addCase(saveRMPUChecksheetData.rejected, (state, action) => {
        state.storedRMPUData.loading = false;
        state.storedRMPUData.success = false;
        state.storedRMPUData.error = action.payload || 'Something went wrong';
      })
      .addCase(fetchRMPUChecksheetData.pending, (state) => {
        state.rmpuList.loading = true;
        state.rmpuList.error = null;
      })
      .addCase(fetchRMPUChecksheetData.fulfilled, (state, action) => {
        state.rmpuList.loading = false;
        state.rmpuList.success = true;
        state.rmpuList.data = action.payload?.data || [];
        state.rmpuList.total = action.payload?.total || 0;
      })
      .addCase(fetchRMPUChecksheetData.rejected, (state, action) => {
        state.rmpuList.loading = false;
        state.rmpuList.success = false;
        state.rmpuList.error = action.payload || 'Something went wrong';
      })
      .addCase(fetchRMPUChecksheetStageById.pending, (state) => {
        state.rmpuStageById.loading = true;
        state.rmpuStageById.error = null;
        state.rmpuStageById.success = false;
      })
      .addCase(fetchRMPUChecksheetStageById.fulfilled, (state, action) => {
        state.rmpuStageById.loading = false;
        state.rmpuStageById.success = true;
        state.rmpuStageById.data = action.payload;
      })
      .addCase(fetchRMPUChecksheetStageById.rejected, (state, action) => {
        state.rmpuStageById.loading = false;
        state.rmpuStageById.success = false;
        state.rmpuStageById.error = action.payload || 'Something went wrong';
      })
      .addCase(deleteRMPUChecksheet.pending, (state) => {
        state.deleteRMPU.loading = true;
        state.deleteRMPU.error = null;
        state.deleteRMPU.success = false;
      })
      .addCase(deleteRMPUChecksheet.fulfilled, (state, action) => {
        state.deleteRMPU.loading = false;
        state.deleteRMPU.success = true;
        state.deleteRMPU.data = action.payload;
      })
      .addCase(deleteRMPUChecksheet.rejected, (state, action) => {
        state.deleteRMPU.loading = false;
        state.deleteRMPU.success = false;
        state.deleteRMPU.error = action.payload || 'Something went wrong';
      })
      .addCase(rmpuInspectionAction.pending, (state) => {
        state.rmpuAction.loading = true;
        state.rmpuAction.error = null;
        state.rmpuAction.success = false;
      })
      .addCase(rmpuInspectionAction.fulfilled, (state, action) => {
        state.rmpuAction.loading = false;
        state.rmpuAction.success = true;
        state.rmpuAction.data = action.payload;
      })
      .addCase(rmpuInspectionAction.rejected, (state, action) => {
        state.rmpuAction.loading = false;
        state.rmpuAction.success = false;
        state.rmpuAction.error = action.payload || 'Something went wrong';
      })
      .addCase(fetchRMPUChecksheetViewData.pending, (state) => {
        state.rmpuViewData.loading = true;
        state.rmpuViewData.error = null;
        state.rmpuViewData.success = false;
      })
      .addCase(fetchRMPUChecksheetViewData.fulfilled, (state, action) => {
        state.rmpuViewData.loading = false;
        state.rmpuViewData.success = true;
        state.rmpuViewData.data = action.payload || null;
      })
      .addCase(fetchRMPUChecksheetViewData.rejected, (state, action) => {
        state.rmpuViewData.loading = false;
        state.rmpuViewData.success = false;
        state.rmpuViewData.error = action.payload || 'Something went wrong';
      })
      .addCase(fetchRMPUFlowHistory.pending, (state) => {
        state.rmpuFlowHistory.loading = true;
        state.rmpuFlowHistory.error = null;
        state.rmpuFlowHistory.success = false;
      })
      .addCase(fetchRMPUFlowHistory.fulfilled, (state, action) => {
        state.rmpuFlowHistory.loading = false;
        state.rmpuFlowHistory.success = true;
        state.rmpuFlowHistory.data = action.payload?.data || action.payload || [];
      })
      .addCase(fetchRMPUFlowHistory.rejected, (state, action) => {
        state.rmpuFlowHistory.loading = false;
        state.rmpuFlowHistory.success = false;
        state.rmpuFlowHistory.error = action.payload || 'Something went wrong';
      })
      // Dashboard
      .addCase(fetchElectricalDashboard.pending, (state) => {
        state.dashboardData.loading = true;
        state.dashboardData.error = null;
        state.dashboardData.success = false;
      })
      .addCase(fetchElectricalDashboard.fulfilled, (state, action) => {
        state.dashboardData.loading = false;
        state.dashboardData.success = true;
        state.dashboardData.data = action.payload?.data;
        state.dashboardData.isFiltered = false;
      })
      .addCase(fetchElectricalDashboard.rejected, (state, action) => {
        state.dashboardData.loading = false;
        state.dashboardData.success = false;
        state.dashboardData.error = action.payload || 'Something went wrong';
      })
      .addCase(fetchCoachNoByFrameType.pending, (state) => {
        state.coachNoData.loading = true;
        state.coachNoData.error = null;
      })
      .addCase(fetchCoachNoByFrameType.fulfilled, (state, action) => {
        state.coachNoData.loading = false;
        state.coachNoData.success = true;
        state.coachNoData.data = action.payload?.data || [];
      })
      .addCase(fetchCoachNoByFrameType.rejected, (state, action) => {
        state.coachNoData.loading = false;
        state.coachNoData.error = action.payload || 'Something went wrong';
      })
      .addCase(addQFRPreCeilingData.pending, (state) => {
        state.storeQrfPreceilingData.loading = true;
        state.storeQrfPreceilingData.error = null;
        state.storeQrfPreceilingData.success = false;
      })
      .addCase(addQFRPreCeilingData.fulfilled, (state, action) => {
        state.storeQrfPreceilingData.loading = false;
        state.storeQrfPreceilingData.success = true;
        state.storeQrfPreceilingData.data = action.payload;
      })
      .addCase(addQFRPreCeilingData.rejected, (state, action) => {
        state.storeQrfPreceilingData.loading = false;
        state.storeQrfPreceilingData.success = false;
        state.storeQrfPreceilingData.error = action.payload || 'Something went wrong';
      })
      .addCase(addTractionMotorVB.pending, (state) => {
        state.TractionMotorVBStoreData.loading = true;
        state.TractionMotorVBStoreData.error = null;
      })
      .addCase(addTractionMotorVB.fulfilled, (state, action) => {
        state.TractionMotorVBStoreData.loading = false;
        state.TractionMotorVBStoreData.data = action.payload.data;
      })
      .addCase(addTractionMotorVB.rejected, (state, action) => {
        state.TractionMotorVBStoreData.loading = false;
        state.TractionMotorVBStoreData.error =
          action.payload || 'Failed to save traction motor VB data';
      })
      
      .addCase(fetchListTractionMotorVB.pending, (state) => {
        state.TractionMotorVBListData.loading = true;
        state.TractionMotorVBListData.success = false;
        state.TractionMotorVBListData.error = null;
      })
      .addCase(fetchListTractionMotorVB.fulfilled, (state, action) => {
        state.TractionMotorVBListData.loading = false;
        state.TractionMotorVBListData.success = true;
        state.TractionMotorVBListData.data = action.payload?.data || [];
        state.TractionMotorVBListData.pagination = {
          current_page: action.payload?.current_page || 1,
          per_page: action.payload?.per_page || 10,
          total: action.payload?.total || 0,
          total_pages: action.payload?.total_pages || 0,
        };
      })
      .addCase(fetchListTractionMotorVB.rejected, (state, action) => {
        state.TractionMotorVBListData.loading = false;
        state.TractionMotorVBListData.success = false;
        state.TractionMotorVBListData.error =
          action.payload || 'Failed to fetch traction motor VB list';
      })
      .addCase(fetchTractionMotorVBById.pending, (state) => {
        state.tractionMotorVBDetail.loading = true;
        state.tractionMotorVBDetail.error = null;
      })
      .addCase(fetchTractionMotorVBById.fulfilled, (state, action) => {
        state.tractionMotorVBDetail.loading = false;
        state.tractionMotorVBDetail.data = action.payload.data;
      })
      .addCase(fetchTractionMotorVBById.rejected, (state, action) => {
        state.tractionMotorVBDetail.loading = false;
        state.tractionMotorVBDetail.error =
          action.payload || 'Failed to fetch traction motor VB details';
      })
      .addCase(tractionMotorInspectionActionVB.pending, (state) => {
        state.TractionMotorVBStoreData.loading = true;
        state.TractionMotorVBStoreData.error = null;
      })
      .addCase(tractionMotorInspectionActionVB.fulfilled, (state, action) => {
        state.TractionMotorVBStoreData.loading = false;
        state.TractionMotorVBStoreData.data = action.payload.data;
      })
      .addCase(tractionMotorInspectionActionVB.rejected, (state, action) => {
        state.TractionMotorVBStoreData.loading = false;
        state.TractionMotorVBStoreData.error =
          action.payload || 'Failed to update traction motor VB';
      })
      .addCase(fetchTractionMotorVBFlowHistory.pending, (state) => {
        state.tractionMotorVBFlowHistory.loading = true;
        state.tractionMotorVBFlowHistory.error = null;
      })
      .addCase(fetchTractionMotorVBFlowHistory.fulfilled, (state, action) => {
        state.tractionMotorVBFlowHistory.loading = false;
        state.tractionMotorVBFlowHistory.data = action.payload.data;
      })
      .addCase(fetchTractionMotorVBFlowHistory.rejected, (state, action) => {
        state.tractionMotorVBFlowHistory.loading = false;
        state.tractionMotorVBFlowHistory.error = action.payload || 'Failed to fetch flow history';
      })
      .addCase(deleteTractionMotorVB.pending, (state) => {
        state.deleteTractionData.loading = true;
        state.deleteTractionData.error = null;
      })
      .addCase(deleteTractionMotorVB.fulfilled, (state, action) => {
        state.deleteTractionData.loading = false;
        state.deleteTractionData.data = action.payload.data;
      })
      .addCase(deleteTractionMotorVB.rejected, (state, action) => {
        state.deleteTractionData.loading = false;
        state.deleteTractionData.error = action.payload || 'Failed to fetch flow history';
      })
      .addCase(checkRecordExist.pending, (state) => {
        state.checkRecord.loading = true;
        state.checkRecord.error = null;
        state.checkRecord.exists = false;
      })
      .addCase(checkRecordExist.fulfilled, (state, action) => {
        console.log(831, action.payload?.data?.data?.exists)
        state.checkRecord.loading = false;
        state.checkRecord.data = action.payload.data;
        state.checkRecord.exists = action.payload?.data?.data?.exists || false;
        state.checkRecord.error = null;
      })
      .addCase(checkRecordExist.rejected, (state, action) => {
        state.checkRecord.loading = false;
        state.checkRecord.error = action.payload || 'Failed to check record';
        state.checkRecord.exists = false;
        state.checkRecord.data = null;
      })
      // Create Air Delivery
      .addCase(createAirDelivery.pending, (state) => {
        state.createAirDelivery.loading = true;
        state.createAirDelivery.error = null;
        state.createAirDelivery.success = false;
      })
      .addCase(createAirDelivery.fulfilled, (state, action) => {
        state.createAirDelivery.loading = false;
        state.createAirDelivery.success = true;
        state.createAirDelivery.data = action.payload?.data || action.payload || null;
      })
      .addCase(createAirDelivery.rejected, (state, action) => {
        state.createAirDelivery.loading = false;
        state.createAirDelivery.success = false;
        state.createAirDelivery.error = action.payload || 'Failed to create air delivery';
      })
      // Fetch Air Delivery List
      .addCase(fetchAirDeliveryList.pending, (state) => {
        state.airDeliveryList.loading = true;
        state.airDeliveryList.error = null;
        state.airDeliveryList.success = false;
      })
      .addCase(fetchAirDeliveryList.fulfilled, (state, action) => {
        state.airDeliveryList.loading = false;
        state.airDeliveryList.success = true;
        state.airDeliveryList.data = action.payload?.data || [];
        state.airDeliveryList.pagination = {
          current_page: action.payload?.current_page || 1,
          per_page: action.payload?.per_page || 10,
          total: action.payload?.total || 0,
          total_pages: action.payload?.total_pages || 0,
        };
      })
      .addCase(fetchAirDeliveryList.rejected, (state, action) => {
        state.airDeliveryList.loading = false;
        state.airDeliveryList.success = false;
        state.airDeliveryList.error = action.payload || 'Failed to fetch air delivery list';
      })
      // Update Air Delivery Flow Status
.addCase(updateAirDeliveryFlowStatus.pending, (state) => {
  state.updateAirDeliveryFlowStatus.loading = true;
  state.updateAirDeliveryFlowStatus.error = null;
  state.updateAirDeliveryFlowStatus.success = false;
})
.addCase(updateAirDeliveryFlowStatus.fulfilled, (state, action) => {
  state.updateAirDeliveryFlowStatus.loading = false;
  state.updateAirDeliveryFlowStatus.success = true;
  state.updateAirDeliveryFlowStatus.data = action.payload;
})
.addCase(updateAirDeliveryFlowStatus.rejected, (state, action) => {
  state.updateAirDeliveryFlowStatus.loading = false;
  state.updateAirDeliveryFlowStatus.success = false;
  state.updateAirDeliveryFlowStatus.error = action.payload || 'Failed to update status';
})
.addCase(deleteAirDelivery.pending, (state) => {
  state.deleteAirDelivery.loading = true;
  state.deleteAirDelivery.error = null;
  state.deleteAirDelivery.success = false;
})
.addCase(deleteAirDelivery.fulfilled, (state, action) => {
  state.deleteAirDelivery.loading = false;
  state.deleteAirDelivery.success = true;
  state.deleteAirDelivery.data = action.payload;
})
.addCase(deleteAirDelivery.rejected, (state, action) => {
  state.deleteAirDelivery.loading = false;
  state.deleteAirDelivery.success = false;
  state.deleteAirDelivery.error = action.payload || 'Failed to delete record';
})
  },
});

export const {
  resetStoreRoofPrecelling,
  resetUpdateFlowStatus,
  clearRoofPrecellingHistory,
  resetRoofPrecellingView,
  getEleFinalQualityInspectionList,
  clearFinalQualityParams,
  resetDashboard,
  setDateFromFilter,
  setDateToFilter,
  setShiftFilter,
  setShellTypeFilter,
  resetFilters,
  resetCreateAirDeliveryState,
} = electricalSlice.actions;

export default electricalSlice.reducer;